import { render, staticRenderFns } from "./MealIngredientsEditor.vue?vue&type=template&id=4cf18b99&scoped=true&"
import script from "./MealIngredientsEditor.vue?vue&type=script&lang=js&"
export * from "./MealIngredientsEditor.vue?vue&type=script&lang=js&"
import style0 from "./MealIngredientsEditor.vue?vue&type=style&index=0&id=4cf18b99&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf18b99",
  null
  
)

export default component.exports